const TMX_IFRAME_ID = 'tmx_tags_iframe';

export { TMX_IFRAME_ID };
